export const images = {
    carstoreLogo: require("../assets/images/logo/carstore.svg").default,
    citroenLogo: require("../assets/images/logo/citroen.svg").default,
    citroenWhiteLogo: require("../assets/images/logo/citroen_white.svg").default,
    isoLogoTipoAnimated: require("../assets/images/logo/isologotipoAnimated.svg").default,
    notFoundPage: require("../assets/images/notFoundPage.png"),
    exterior: require("../assets/images/exterior.svg").default,
    interior: require("../assets/images/interior.svg").default,
    technicalData: require("../assets/images/technicalData.svg").default,
    success: require("../assets/images/success.png"),
    citroenHeaderIcon: require("../assets/images/citroen_icon.png"),
    linzeWhatsIcon: require("../assets/images/linze_whats_icon.png"),
    shoppingBasket: require("../assets/images/shopping_basket.png"),
    accountIcon: require("../assets/images/account_icon.png"),
    banner: require("../assets/images/banner.png"),
    arrowBack: require("../assets/images/back_arrow.png"),
    warningIcon: require("../assets/images/warning_icon.png"),
    miniCar: require("../assets/images/mini_car.png"),
    miniWheel: require("../assets/images/mini_wheel.png"),
    suvIcon: require("../assets/images/suv_icon.png"),
    doorsIcon: require("../assets/images/door_icon.png"),
    transmissionIcon: require("../assets/images/transmission_icon.png"),
    fuelIcon: require("../assets/images/fuel_icon.png"),
    verticalArrow: require("../assets/images/arrow_vertical.png"),
    olxIcon: require("../assets/images/olx_icon.png"),
    linzeIcon: require("../assets/images/linze_icon.png"),
    horizontalArrow: require("../assets/images/horizontal_red_arrow.png"),
    pagaEnLineaIcon: require("../assets/images/pagaenlinea_icon.png"),
    transbankIcon: require("../assets/images/transbank_icon.png"),
    mpIcon: require("../assets/images/mp_icon.png"),
    loading: require("../assets/images/loading.png"),
    closeIcon: require("../assets/images/close_icon.png"),
    whatsAppIcon: require("../assets/images/whatsapp_icon.png"),
    addIcon: require("../assets/images/add.png"),
    removeIcon: require("../assets/images/remove.png"),
    characteristics1: require("../assets/images/char_1.png"),
    characteristics2: require("../assets/images/char_2.png"),
    characteristics3: require("../assets/images/char_3.png"),
    characteristics4: require("../assets/images/char_4.png"),
    citroenFooter: require("../assets/images/citroen_store.png"),
    byLinze: require("../assets/images/powered_linze.png"),
    arrowUp: require("../assets/images/arrow_up.png"),
    defaultCitroen: require("../assets/images/default_citroen.png"),
    modalCreditImg: require("../assets/images/credit_modal_img.png"),
    rememberIcon: require("../assets/images/remember_icon.png"),
    floatLinzeIcon: require("../assets/images/float_linze.png"),
    info: require("../assets/images/info.png"),
    download: require("../assets/images/download.png"),
    fakec3: require("../assets/images/fakec3.png"),
    fakec3AirCross: require("../assets/images/fakec3AirCross.png"),
    fakec4: require("../assets/images/fakec4.png")
}